module.exports = __webpack_public_path__ + "media/team_photos/Endre-Kiring-photo-30aafbeb.webp";